import { ParsedUrlQuery } from 'querystring';

export function getGeoAutocompleteIdentifier(query: ParsedUrlQuery) {
    if (query['geo_autocomplete_identifier']) {
        return query['geo_autocomplete_identifier'];
    }

    return '';
}
